// import React from "react";

// const Yatak = () => {
//   return (
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <div className="text-sm text-gray-600 mb-4">
//         <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Yatak Yıkama
//       </div>

//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">ANKARA YATAK YIKAMA HİZMETİ</h1>

//       <div className="space-y-6">
//         <p>
//           Abone Halı Yıkama olarak sadece halı ve koltuk değil, yatak temizliği alanında da Ankara genelinde profesyonel hizmet sunuyoruz. Yataklarınızda zamanla biriken bakteri, toz ve lekeler için özel sistemlerimizle yerinde hijyen sağlıyoruz.
//         </p>

//         <p>
//           Yataklar, insan sağlığını doğrudan etkileyen önemli eşyalar arasında yer alır. Günlük kullanımda ter, cilt kalıntıları ve toz akarları birikir. Bu birikim zamanla sağlık sorunlarına neden olabilir. Biz de bu süreci kontrol altına alarak sizlere tertemiz yataklar sunuyoruz.
//         </p>

//         <p>
//           Özel makinelerimiz ve antibakteriyel temizlik ürünlerimiz ile yatak kumaşına zarar vermeden derinlemesine temizlik sağlıyoruz. Bu işlem sırasında kullanılan tüm solüsyonlar, insan sağlığına zararsız ve çevre dostudur.
//         </p>

//         <p>
//           Evinize gelerek yerinde uygulama gerçekleştiren ekiplerimiz, kısa sürede hijyenik bir yatak temizliği sağlar. Size sadece sağlıklı bir uykunun keyfini çıkarmak kalır.
//         </p>

//         <p>
//           Ankara’da yerinde yatak yıkama hizmeti almak isteyen müşterilerimiz için 7/24 ulaşılabilir durumdayız. WhatsApp hattımızdan hızlıca randevu alabilirsiniz.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">🛏️ Profesyonel Yatak Yıkama Hizmeti</h2>
//         <p>
//           Yataklar, görünmeyen mikroorganizmalar ve lekelerle doludur. Firmamız bu zararlı birikimleri yok ederek yatağınızı hijyenik hale getirir, ilk günkü temizliğine kavuşturur.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">💧 Yatak Yıkama Sürecimiz</h2>
//         <ol className="list-decimal list-inside space-y-2">
//           <li>Yatak tipi ve leke analizi</li>
//           <li>Toz ve partikül temizliği</li>
//           <li>Leke çıkarma ve özel müdahale</li>
//           <li>Antibakteriyel şampuanla yıkama</li>
//           <li>Durulama ve nem alma işlemi</li>
//           <li>Hızlı kurutma sistemi</li>
//           <li>Son kontrol ve bilgilendirme</li>
//         </ol>

//         <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
//         <ul className="list-disc list-inside">
//           <li>Alerjiye neden olmayan antibakteriyel yatak şampuanları</li>
//           <li>İnsan sağlığına zararsız doğal içerikli ürünler</li>
//           <li>Koku giderici ve mikrop önleyici özel solüsyonlar</li>
//         </ul>

//         <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
//         <ul className="list-disc list-inside">
//           <li>Yerinde hizmet imkanı ile zaman tasarrufu</li>
//           <li>Yatak kumaşına özel temizlik teknikleri</li>
//           <li>Modern makine ve uzman personel</li>
//           <li>Memnuniyet garantili hizmet</li>
//           <li>Uygun fiyat – yüksek hijyen standardı</li>
//         </ul>

//         <p>
//           Yatak yıkama işlemlerimizde titizlik önceliğimizdir. Hijyenik, sağlıklı ve profesyonel temizlikle yatağınızda huzurla uyuyun. Hemen bize ulaşın, hizmeti yerinizde sunalım.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Yatak;
import React from "react";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const Yatak = () => {
  return (
    <>
      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü için */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <div className="text-sm text-gray-600 mb-4">
            <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp;
            <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Yatak Yıkama
          </div>

          <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
            ANKARA YATAK YIKAMA HİZMETİ
          </h1>

          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              Abone Halı Yıkama olarak sadece halı ve koltuk değil, yatak temizliği alanında da Ankara genelinde profesyonel hizmet sunuyoruz. Yataklarınızda zamanla biriken bakteri, toz ve lekeler için özel sistemlerimizle yerinde hijyen sağlıyoruz.
            </p>

            <p>
              Yataklar, insan sağlığını doğrudan etkileyen önemli eşyalar arasında yer alır. Günlük kullanımda ter, cilt kalıntıları ve toz akarları birikir. Bu birikim zamanla sağlık sorunlarına neden olabilir. Biz de bu süreci kontrol altına alarak sizlere tertemiz yataklar sunuyoruz.
            </p>

            <p>
              Özel makinelerimiz ve antibakteriyel temizlik ürünlerimiz ile yatak kumaşına zarar vermeden derinlemesine temizlik sağlıyoruz. Bu işlem sırasında kullanılan tüm solüsyonlar, insan sağlığına zararsız ve çevre dostudur.
            </p>

            <p>
              Evinize gelerek yerinde uygulama gerçekleştiren ekiplerimiz, kısa sürede hijyenik bir yatak temizliği sağlar. Size sadece sağlıklı bir uykunun keyfini çıkarmak kalır.
            </p>

            <p>
              Ankara’da yerinde yatak yıkama hizmeti almak isteyen müşterilerimiz için 7/24 ulaşılabilir durumdayız. WhatsApp hattımızdan hızlıca randevu alabilirsiniz.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">🛏️ Profesyonel Yatak Yıkama Hizmeti</h2>
            <p>
              Yataklar, görünmeyen mikroorganizmalar ve lekelerle doludur. Firmamız bu zararlı birikimleri yok ederek yatağınızı hijyenik hale getirir, ilk günkü temizliğine kavuşturur.
            </p>

            <h2 className="text-xl font-bold text-[#003132]">💧 Yatak Yıkama Sürecimiz</h2>
            <ol className="list-decimal list-inside space-y-2">
              <li>Yatak tipi ve leke analizi</li>
              <li>Toz ve partikül temizliği</li>
              <li>Leke çıkarma ve özel müdahale</li>
              <li>Antibakteriyel şampuanla yıkama</li>
              <li>Durulama ve nem alma işlemi</li>
              <li>Hızlı kurutma sistemi</li>
              <li>Son kontrol ve bilgilendirme</li>
            </ol>

            <h2 className="text-xl font-bold text-[#003132]">🧴 Kullandığımız Ürünler</h2>
            <ul className="list-disc list-inside">
              <li>Alerjiye neden olmayan antibakteriyel yatak şampuanları</li>
              <li>İnsan sağlığına zararsız doğal içerikli ürünler</li>
              <li>Koku giderici ve mikrop önleyici özel solüsyonlar</li>
            </ul>

            <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
            <ul className="list-disc list-inside">
              <li>Yerinde hizmet imkanı ile zaman tasarrufu</li>
              <li>Yatak kumaşına özel temizlik teknikleri</li>
              <li>Modern makine ve uzman personel</li>
              <li>Memnuniyet garantili hizmet</li>
              <li>Uygun fiyat – yüksek hijyen standardı</li>
            </ul>

            <p>
              Yatak yıkama işlemlerimizde titizlik önceliğimizdir. Hijyenik, sağlıklı ve profesyonel temizlikle yatağınızda huzurla uyuyun. Hemen bize ulaşın, hizmeti yerinizde sunalım.
            </p>
          </div>

          {/* Mobilde sola düşen sidebar */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>
    </>
  );
};

export default Yatak;
